import { StrictMode } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "@fontsource-variable/bricolage-grotesque/wght.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/700.css";
import "./index.css";

const raiz = document.getElementById("root");

const arbol = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

// Las rutas llegan prerenderizadas, así que se hidratan en vez de
// renderizarse de cero. Si el HTML viniera vacío (por ejemplo en `dev`),
// se monta normalmente.
if (raiz.hasChildNodes()) {
  hydrateRoot(raiz, arbol);
} else {
  createRoot(raiz).render(arbol);
}

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
